module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "taoqg"
    }
  }, [_c('div', {
    staticClass: "count-down"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/images/tqg.jpg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "count-down-num"
  }, [_c('div', {
    staticClass: "countTime-h"
  }, [_vm._v(_vm._s(_vm._f("number2")(_vm.countTimeH)))]), _vm._v(" : "), _c('div', {
    staticClass: "countTime-m"
  }, [_vm._v(_vm._s(_vm._f("number2")(_vm.countTimeM)))]), _vm._v(" : "), _c('div', {
    staticClass: "countTime-s"
  }, [_vm._v(_vm._s(_vm._f("number2")(_vm.countTimeS)))])])]), _vm._v(" "), _c('div', {
    staticClass: "other"
  }, _vm._l((_vm.imgs), function(img) {
    return _c('img', {
      attrs: {
        "src": img,
        "alt": ""
      }
    })
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-ef94efb2!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/Index/taoqianggou.vue
// module id = 57
// module chunks = 1